import React from "react";
import { Button, Grid } from "@mui/material";
import useChangePasswordForm from "./useChangePasswordForm";
import SubmitButton from "components/Button/SubmitButton";
import FormPasswordField from "components/FormFields/FormPasswordField";
import { Formik } from "formik";
import { changePasswordValidationSchema } from "schemas/changePasswordValidationSchema";

const ChangePasswordForm = (props) => {
  const { isProcessing, initialValues, handleFormSubmit } =
    useChangePasswordForm(props);

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialValues }}
      validationSchema={changePasswordValidationSchema}
      onSubmit={(values) => handleFormSubmit(values)}
    >
      {({ handleSubmit, touched, errors, values, handleChange, resetForm }) => (
        <>
          <Grid container spacing={1} className="mb-3">
            <Grid item xs={12}>
              <FormPasswordField
                fullWidth
                required={true}
                label="Current Password"
                value={values.currentPassword}
                errorMessage={errors.currentPassword}
                hasError={
                  touched.currentPassword && Boolean(errors.currentPassword)
                }
                onChange={handleChange("currentPassword")}
              />
            </Grid>

            <Grid item xs={12}>
              <FormPasswordField
                fullWidth
                required={true}
                label="New Password"
                value={values.newPassword}
                errorMessage={errors.newPassword}
                hasError={touched.newPassword && Boolean(errors.newPassword)}
                onChange={handleChange("newPassword")}
              />
            </Grid>

            <Grid item xs={12}>
              <FormPasswordField
                fullWidth
                required={true}
                label="Confirm New Password"
                value={values.confirmNewPassword}
                errorMessage={errors.confirmNewPassword}
                hasError={
                  touched.confirmNewPassword &&
                  Boolean(errors.confirmNewPassword)
                }
                onChange={handleChange("confirmNewPassword")}
              />
            </Grid>
          </Grid>

          <div className="d-flex flex-end mt-3" style={{ gap: "10px" }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                props.handleClose();
                resetForm();
              }}
              disabled={isProcessing}
            >
              Cancel
            </Button>

            <SubmitButton
              className="ml-2"
              variant="contained"
              color="secondary"
              handleClick={handleSubmit}
              isLoading={isProcessing}
            />
          </div>
        </>
      )}
    </Formik>
  );
};

export default ChangePasswordForm;
